import Users from './Users';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState, ListView } from 'model/state';
import { selectAccountId, selectLoggedUser } from 'selectors/Auth';
import { selectUserList, selectUserSearch } from 'selectors/User';
import { Dispatch } from 'redux';
import { fetchUserList, fetchUser, clearCurrentUser, updateSearch, removeUser, resendUserInvite, revokeUserInvite } from 'actions/User';
import { User } from 'model';
import { selectHasErrorMessage } from 'selectors/Message';
import { selectIsSubmitting } from 'selectors/Common';
import { clearMessage, openConfirmationDialog } from 'actions/Common';

type SelectedValues = {
  accountId?: string,
  userList: ListView<User>,
  hasError: boolean,
  isSubmitting: boolean,
  search: string,
  loggedUser?: User,
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  accountId: selectAccountId(),
  userList: selectUserList(),
  hasError: selectHasErrorMessage(),
  isSubmitting: selectIsSubmitting(),
  search: selectUserSearch(),
  loggedUser: selectLoggedUser(),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchUserList: (accountId: string) => dispatch(fetchUserList(accountId)),
  fetchUser: (userId: string) => dispatch(fetchUser(userId)),
  clearMessage: () => dispatch(clearMessage()),
  clearCurrentUser: () => dispatch(clearCurrentUser()),
  openConfirmationDialog: (metadata?: { [key: string]: any }) => dispatch(openConfirmationDialog(metadata)),
  updateSearch: (search: string) => dispatch(updateSearch(search)),
  removeUser: (userId: string) => dispatch(removeUser(userId)),
  resendUserInvite: (user?: User) => dispatch(resendUserInvite(user)),
  revokeUserInvite: (user?: User) => dispatch(revokeUserInvite(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Users);
